import cleanedFilename from '~/util/cleanedFilename';

export default {
  CreateActivities: `${cleanedFilename(__filename)}-create-activities`,
};
